// extracted by mini-css-extract-plugin
export default {"select":"Select-module__select__4A3E6","wide":"Select-module__wide__zwH6a"};